@for (ordersType of orders; track ordersType.id) {
<h5>
  {{ ordersType.name || '-' | translate }}
  @if (ordersType.warehouse) {
  <span class="ml-1">({{ 'BLOCK_ORDER_WAREHOUSE' | translate }}: {{ ordersType.warehouse }})</span>
  }
</h5>
<div class="table-responsive gung-responsive">
  <table class="table">
    <thead>
      <tr>
        <th translate class="t-col-id" (click)="sortColumn('agreementId')">
          BLOCK_ORDER_AGREEMENT_ID
          <i *ngIf="headerSort.agreementId" class="fas" [ngClass]="{
                'fa-sort-amount-down': headerSort.agreementId === 'asc',
                'fa-sort-amount-up': headerSort.agreementId === 'desc'
              }"></i>
        </th>
        @if (!customerDetails) {
        <th translate class="t-col-customer" (click)="sortColumn('customerId')">
          CUSTOMER
          <i *ngIf="headerSort.customerId" class="fas" [ngClass]="{
                  'fa-sort-amount-down': headerSort.customerId === 'asc',
                  'fa-sort-amount-up': headerSort.customerId === 'desc'
                }"></i>
        </th>
        } @else {
        <th translate (click)="sortColumn('offbeskr')">
          BLOCK_ORDER_CONTRACT
          <i *ngIf="headerSort.offbeskr" class="fas" [ngClass]="{
                  'fa-sort-amount-down': headerSort.offbeskr === 'asc',
                  'fa-sort-amount-up': headerSort.offbeskr === 'desc'
                }"></i>
        </th>

        <th translate (click)="sortColumn('contact')">
          BLOCK_ORDER_CONTACT
          <i *ngIf="headerSort.contact" class="fas" [ngClass]="{
                  'fa-sort-amount-down': headerSort.contact === 'asc',
                  'fa-sort-amount-up': headerSort.contact === 'desc'
                }"></i>
        </th>
        <th translate (click)="sortColumn('refNumber')">
          BLOCK_ORDER_REF_NUMBER
          <i *ngIf="headerSort.refNumber" class="fas" [ngClass]="{
                  'fa-sort-amount-down': headerSort.refNumber === 'asc',
                  'fa-sort-amount-up': headerSort.refNumber === 'desc'
                }"></i>
        </th>
        }
        <th translate (click)="sortColumn('status')">
          BLOCK_ORDER_STATUS
          <i *ngIf="headerSort.status" class="fas" [ngClass]="{
                'fa-sort-amount-down': headerSort.status === 'asc',
                'fa-sort-amount-up': headerSort.status === 'desc'
              }"></i>
        </th>
        <th translate (click)="sortColumn('selger')">
          SALES
          <i *ngIf="headerSort.status" class="fas" [ngClass]="{
                'fa-sort-amount-down': headerSort.status === 'asc',
                'fa-sort-amount-up': headerSort.status === 'desc'
              }"></i>
        </th>

        <th translate class="t-col-aggr-date" (click)="sortColumn('agreementDate')">
          BLOCK_ORDER_AGREEMENT_DATE
          <i *ngIf="headerSort.agreementDate" class="fas" [ngClass]="{
                'fa-sort-amount-down': headerSort.agreementDate === 'asc',
                'fa-sort-amount-up': headerSort.agreementDate === 'desc'
              }"></i>
        </th>

        <th translate class="t-col-valid-date" (click)="sortColumn('agreementValidToDate')">
          BLOCK_ORDER_AGREEMENT_VALID_TO_DATE
          <i *ngIf="headerSort.agreementValidToDate" class="fas" [ngClass]="{
                'fa-sort-amount-down': headerSort.agreementValidToDate === 'asc',
                'fa-sort-amount-up': headerSort.agreementValidToDate === 'desc'
              }"></i>
        </th>

        <th translate class="t-col-valid-date" (click)="sortColumn('agreementTotalValue')">
          BLOCK_ORDER_AGREEMENT_TOTAL_VALUE
          <i *ngIf="headerSort.agreementTotalValue" class="fas" [ngClass]="{
                'fa-sort-amount-down': headerSort.agreementTotalValue === 'asc',
                'fa-sort-amount-up': headerSort.agreementTotalValue === 'desc'
              }"></i>
        </th>

        <th class="t-col-actions" *ngIf="hasAccessToCreate"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let group of ordersType.groupedOrder; index as i">
        <tr>
          <td [attr.data-label]="'BLOCK_ORDER_AGREEMENT_ID' | translate">
            <button type="button" class="btn btn-link" (click)="
                  icon.classList.toggle('fa-arrow-turn-up');
                  icon.classList.toggle('fa-arrow-turn-down');
                  toggleLines(group)
                ">
              <i #icon class="fa-solid fa-arrow-turn-up fa-rotate-180"></i>
            </button>
            <span class="text-nowrap">
              {{ group.agreementId }}
            </span>
          </td>
          @if (!customerDetails) {
          <td [attr.data-label]="'CUSTOMER' | translate">
            <span class="text-nowrap">
              <b>{{ group.customerId }}</b> - {{ group.customerName }}
            </span>
          </td>
          } @else {
          <td [attr.data-label]="'BLOCK_ORDER_AGREEMENT_DATE' | translate">
            <span>{{ group.offbeskr }}</span>
          </td>

          <td [attr.data-label]="'BLOCK_ORDER_AGREEMENT_DATE' | translate">
            <span>{{ group.contact }}</span>
          </td>
          <td [attr.data-label]="'BLOCK_ORDER_AGREEMENT_DATE' | translate">
            <span>{{ group.refNumber }}</span>
          </td>
          }
          <td [attr.data-label]="'BLOCK_ORDER_AGREEMENT_DATE' | translate">
            <span>{{ group.status }}</span>
          </td>
          <td [attr.data-label]="'SALES' | translate">
            <span>{{ group.selger }}</span>
          </td>

          <td [attr.data-label]="'BLOCK_ORDER_AGREEMENT_DATE' | translate">
            <span>{{ group.agreementDate | date: 'yyyy-MM-dd' }}</span>
          </td>

          <td [attr.data-label]="'BLOCK_ORDER_AGREEMENT_VALID_TO_DATE' | translate">
            <span>{{ group.agreementValidToDate | date: 'yyyy-MM-dd' }}</span>
          </td>

          <td [attr.data-label]="'BLOCK_ORDER_AGREEMENT_TOTAL_VALUE' | translate">
            <lib-price [price]="group?.agreementTotalValue || 0"
              [currency]="group?.rows?.[0]?.extra?.q_gung_ofh?.valkod"></lib-price>
          </td>

          <td class="text-right" *ngIf="hasAccessToCreate">
            @if(group.signingStatus !=='INVITATION_SENT' && group.signingStatus !=='SIGNED'){
            <gung-button classes="btn-secondary btn ml-1 my-1" icon="fa-solid fa-signature"
              [onClick]="signing.bind(this, group)" label="{{ 'SIGNING' | translate }}" />
            }

            <gung-button classes="btn-secondary btn ml-1 my-1" icon="fa-regular fa-file-pdf"
              [onClick]="download.bind(this, group.agreementId)" label="{{ 'DOWNLOAD' | translate }}" />
            <!-- @if (uploading[group.agreementId]) {
                <div class="spinner-grow ml-2 mt-2" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              } @else {
                <label for="file-input-{{ i }} my-1" class="label-file btn btn-secondary ml-1">
                  <i class="fa-regular fa-upload"></i><span translate>UPLOAD</span>
                </label>
                <input type="file" id="file-input-{{ i }}" (change)="upload($event, group)" style="opacity: 0" />
              } -->
            @if (group.signingStatus && !this.signingStatus[group.agreementId]) {
            <gung-button classes="btn-secondary btn ml-1 my-1" icon="fa-solid fa-signature"
              [onClick]="checkSigningStatus.bind(this, group.agreementId)" label="{{ 'SIGNING_STATUS' | translate }}" />
            }

            @if (this.signingStatus[group.agreementId]) {
            <span class="ml-1">
              @if (
              this.signingStatus[group.agreementId] === 'NEW' ||
              this.signingStatus[group.agreementId] === 'DOCUMENT_CREATED' ||
              this.signingStatus[group.agreementId] === 'FILES_UPLOADED'
              ) {
              <span class="gray-icon">
                <i class="fa-solid fa-hourglass-half"
                  title="{{ this.signingStatus[group.agreementId] | translate }}"></i>&nbsp;{{
                this.signingStatus[group.agreementId] | translate }}
              </span>
              } @else if (this.signingStatus[group.agreementId] === 'INVITATION_SENT') {
              <span class="status-checked">
                <span class="yellow-icon text-truncate">
                  <i class="fa-regular fa-clock"
                    title="{{ this.signingStatus[group.agreementId] | translate }}"></i>&nbsp;{{
                  this.signingStatus[group.agreementId] | translate }}
                </span>
              </span>

              } @else if (this.signingStatus[group.agreementId] === 'SIGNED') {
              <span class="status-checked">
                <span class="green-icon">
                  <i title="{{ this.signingStatus[group.agreementId] | translate }}"
                    class="fa-regular fa-square-check"></i>
                  &nbsp;{{ this.signingStatus[group.agreementId] | translate }}
                </span>
              </span>

              }
            </span>
            }
          </td>
        </tr>
        <tr #productsRow *ngIf="showGroup[group.agreementId]">
          <td colspan="10" class="p-0">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">
                    <span translate>OO_BOA_VARENUMMER</span>
                  </th>
                  <th scope="col">
                    <span translate>OO_BOA_BESKRIVELSE</span>
                  </th>
                  <th scope="col">
                    <span translate>OO_BOA_LAGERSTATUS</span>
                  </th>
                  <th scope="col">
                    <span translate>PRICE</span>
                  </th>
                  <th scope="col">
                    <span translate>UNIT</span>
                  </th>
                  <th scope="col">
                    <span translate>OO_BOA_PROGNOSE</span>
                  </th>

                  <th scope="col">
                    @if (ordersType.id === 973) {
                    <span translate>PRODUCTION_START</span>
                    } @else {
                    <span translate>AGREEMENT_QTY</span>
                    }
                  </th>
                  @if (ordersType.id === 973) {
                  <th scope="col">
                    <span translate>Q_OO_OFHEOQ</span>
                  </th>
                  }

                  <th scope="col">
                    <span translate>OO_BOA_AVTALEVERDI</span>
                  </th>
                  @if (ordersType.id === 971) {
                  <th scope="col">
                    <span translate>AGREEMENT_QUANTITY_BACKORDER</span>
                  </th>

                  <th scope="col">
                    <span translate>AGREEMENT_VALUE_BACKORDER</span>
                  </th>
                  }

                  <th scope="col" style="width: 120px">
                    <span translate></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of group.rows; let idx = index; trackBy: trackByFn"
                  [ngClass]="{ 'line-checked': !!row.checked }">
                  <td [attr.data-label]="'PRODUCT_ID' | translate">
                    <a [href]="row.extra?._pathToDetails" class="text-nowrap">
                      <small>{{ row.extra.q_gung_ofh?.artnr }}</small> <br />
                    </a>
                    <small class="text-muted"><b *ngIf="
                            row.extra.q_gung_ofh?.ftgnr &&
                            row.extra._product?.extra._customerCrossReferences &&
                            row.extra._product.extra._customerCrossReferences[row.extra.q_gung_ofh.ftgnr]
                          " class="d-block small customer-reference">
                        {{ row.extra._product.extra._customerCrossReferences[row.extra.q_gung_ofh.ftgnr].referenceId }}
                      </b></small>
                  </td>

                  <td [attr.data-label]="'OO_BOA_BESKRIVELSE' | translate">
                    <span class="text-nowrap">
                      <a [href]="row.extra?._pathToDetails">{{ row.extra.q_gung_ofh?.ar_artbeskr }}</a>
                      <br />
                      <small class="text-muted">{{ row.extra._product?.extra?.ar?.artbeskrspec }}</small> <br />
                    </span>
                  </td>

                  <td [attr.data-label]="'OO_BOA_LAGERSTATUS' | translate">
                    @if (row.extra._av) {
                    <otto-olsen-availability [availability]="row.extra._av" [product]="row.extra?._product"
                      [isSales]="isSales" [unit]="row.extra?._product?.extra?.ar?.enhetskod"></otto-olsen-availability>
                    } @else {
                    <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    }
                  </td>

                  <td [attr.data-label]="'PRICE' | translate">
                    <span class="text-nowrap">
                      <small class="text-muted">
                        <lib-price [price]="getPriceWithDiscount(row)"
                          [currency]="row.extra.q_gung_ofh?.valkod"></lib-price>
                        <!--  {{ getPriceWithDiscount(row) | currency: row.extra.q_gung_ofh?.valkod }}  --><br />
                        <!-- @if (row.extra.q_gung_ofh?.rabatt1 != 0.0) {
                            <span>{{ 'PRICE' | translate }}</span
                            >: {{ row.extra.q_gung_ofh?.vb_pris }} ({{ row.extra.q_gung_ofh?.rabatt1 }}%
                            <span>{{ 'DISCOUNT' | translate }}</span
                            >)
                          } @else {
                            (<span>{{ 'NET_PRICE' | translate }}</span
                            >)
                          } -->
                      </small>
                    </span>
                  </td>

                  <td [attr.data-label]="'UNIT' | translate">
                    @if (row.extra._product) {
                    <span class="text-nowrap">
                      <small class="text-muted">{{ row.extra._product?.extra.ar?.enhetskod }}</small>
                    </span>
                    }
                  </td>

                  <td [attr.data-label]="'OO_BOA_PROGNOSE' | translate">
                    <span class="text-nowrap">
                      <small class="text-muted">{{ row.extra.q_gung_ofh?.q_oo_ofhprognose }}</small>
                    </span>
                  </td>

                  <td [attr.data-label]="(ordersType.id === 973 ? 'PRODUCTION_START' : 'AGREEMENT_QTY') | translate">
                    <span class="text-nowrap">
                      <small class="text-muted">{{ row.extra.q_gung_ofh?.ordantal }}</small>
                    </span>
                  </td>
                  @if (ordersType.id === 973) {
                  <td [attr.data-label]="'Q_OO_OFHEOQ' | translate">
                    <span class="text-nowrap">
                      <small class="text-muted">{{ row.extra.q_gung_ofh?.q_oo_ofheoq }}</small>
                    </span>
                  </td>
                  }

                  <td [attr.data-label]="'OO_BOA_AVTALEVERDI' | translate">
                    <span class="text-nowrap">
                      <small class="text-muted">
                        <lib-price [price]="row.extra.q_gung_ofh?.vboffradsum"
                          [currency]="row.extra.q_gung_ofh?.valkod"></lib-price></small>
                    </span>
                  </td>
                  @if (ordersType.id === 971) {
                  <td [attr.data-label]="'AGREEMENT_QUANTITY_BACKORDER' | translate">
                    <span class="text-nowrap">
                      @if (row.extra.q_gung_ofh?.agreementquantitybackorder) {
                      <small class="text-muted">
                        {{row.extra.q_gung_ofh?.agreementquantitybackorder}}
                      </small>
                      }
                    </span>
                  </td>

                  <td [attr.data-label]="'AGREEMENT_VALUE_BACKORDER' | translate">
                    <span class="text-nowrap">
                      @if (row.extra.q_gung_ofh?.agreementValueBackorder) {
                      <small class="text-muted">
                        <lib-price [price]="row.extra.q_gung_ofh?.agreementValueBackorder"
                          [currency]="row.extra.q_gung_ofh?.valkod"></lib-price></small>
                      }
                    </span>
                    <small class="text-muted">
                      <lib-price
                        [price]="(getPriceWithDiscount(row) * row.extra?.q_gung_ofh?.agreementquantitybackorder) || 0"
                        [currency]="row.extra.q_gung_ofh?.valkod"></lib-price></small>
                  </td>
                  }
                  <td>
                    @if (row.extra._product) {
                    <otto-olsen-buy-btn name="buy-btn-package-size" class="height-30 ml-auto" style="width: 150px"
                      [id]="row.extra._product?.id" [minimumOrderQuantity]="
                            row.extra._product?.firstStepAmount || row.extra._product?.packageSize
                          " [stepAmount]="row.extra._product?.packageSize"
                      [decimals]="row.extra._product?.extra.ar.antdec" [originalSize]="row.extra._product?.originalSize"
                      [unit]="row.extra._product?.extra.ar?.enhetskod"
                      [activeInB2B]="row.extra._product?.extra?.pim?.activeInB2B" [product]="row.extra._product"
                      [availability]="row.extra._av"></otto-olsen-buy-btn>
                    }
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
}
